import { IonRouterLink } from '@ionic/react';
import { LocaleSwitcher } from './LocaleSwitcher';

export default function Footer() {
  return (
    <footer className="relative mt-24 w-full overflow-hidden border-t border-neutral-200 px-8 py-20 dark:border-neutral-800 ">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between text-sm text-neutral-500 sm:flex-row md:px-8">
        <div>
          {/* <div className="mb-4 mr-0 md:mr-4 md:flex">
            <IonRouterLink className="relative z-20 mr-4 flex items-center space-x-2 px-2 py-1 text-sm font-normal text-black dark:text-white" href="/">
              <GolfBall className="size-8" />
              <span className="font-medium text-black dark:text-white">GolfPro</span>
            </IonRouterLink>
          </div> */}
          <div className="ml-2 mt-2">
            ©
            {new Date().getFullYear()}
            {' '}
            MyGolfProfile. All rights reserved.
            <br />
            Made by
            {' '}
            <a href="https://antonindesfontaines.com">Antonin Desfontaines</a>
          </div>
          <div className="mt-2 flex space-x-4">
            <LocaleSwitcher />
          </div>
        </div>

        <div className="mt-10 grid grid-cols-3 items-start gap-10 sm:mt-0 md:mt-0 lg:grid-cols-3">
          <div className="flex w-full flex-col justify-center space-y-4">
            <p className="font-bold text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">Features</p>
            <ul className="list-none space-y-4 text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/score-tracking">Score Tracking</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/course-finder">Course Finder</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/social">Social Features</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/statistics">Statistics</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/competitions">Competitions</IonRouterLink></li>
            </ul>
          </div>
          {/* <div className="flex flex-col justify-center space-y-4">
            <p className="font-bold text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">Company</p>
            <ul className="list-none space-y-4 text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/about">About Us</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/careers">Careers</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/press">Press</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/contact">Contact</IonRouterLink></li>
            </ul>
          </div> */}
          <div className="flex flex-col justify-center space-y-4">
            <p className="font-bold text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">Legal</p>
            <ul className="list-none space-y-4 text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/privacy">Privacy Policy</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/terms">Terms of Service</IonRouterLink></li>
            </ul>
          </div>
          <div className="flex flex-col justify-center space-y-4">
            <p className="font-bold text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">Get Started</p>
            <ul className="list-none space-y-4 text-neutral-600 transition-colors hover:text-primary dark:text-neutral-300">
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/signup">Sign Up</IonRouterLink></li>
              <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/login">Login</IonRouterLink></li>
              {/* <li className="list-none"><IonRouterLink className="transition-colors hover:text-primary" href="/download">Download App</IonRouterLink></li> */}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
